module.exports = __webpack_public_path__ + "static/media/164-croatia.b5e27ac5.svg";